export const stripHtmlToText = (html?: string | null): string => {
  if (!html) {
    return ''
  }
  return (new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '').trim()
}
